import React, { useEffect } from "react";
import Modal from "components/modal";
import ProductGallery from "components/product-gallery";
import ProductSummary from "./summary";
import RichText from "components/rich-text";
import Link from "components/link";
import Image from "components/image";
import { trackViewItem } from "analytics";
import { useCustomer } from "hooks/useStore";

const ProductModal = ({ product, isOpen, toggle, secureCheckout }) => {
	const customer = useCustomer();

	useEffect(() => {
		if (isOpen)
			trackViewItem(product, customer, location.pathname);
	}, [isOpen]);

	return (
		<Modal
			isOpen={isOpen}
			close={toggle}
			className="text-center !w-full md:!max-w-screen-lg"
		>
			<div className="flex flex-col md:flex-row px-5 py-2 gap-8">
				<ProductGallery
					className="md:w-1/2"
					productId={product.id}
					title={product.title}
					productImages={product?.images || []}
					variantImages={product.variant?.images || []}
					hideCylindoDynaimcFeature
					customSort
				/>
				<div className="md:w-1/2">
					<ProductSummary product={product} />
					<div className="text-left line-clamp-4 my-6">
						<RichText data={{ content: product.description }} />
					</div>
					<div className="flex gap-3.5 items-center mt-8 mb-2">
						<Link className="w-full py-5 btn-primary" to={`/products/${product.handle}`}>View Details</Link>
					</div>
					{secureCheckout &&
						<div className="w-11/12 mx-auto">
							<Image image={secureCheckout} />
						</div>
					}
				</div>
			</div>
		</Modal>
	);
};


export default ProductModal;
